import React from 'react';
import Card from '../../components/Card/card.js';
import './akwaba.css';

export default function Akwaba() {
		const cartes = [
		{ image: "/images/haca.jpg", title: "Seminaire de formation" },
  	{ image: "/images/haca2.jpg", title: "Formation des animateurs avec la HACA" },
  	{ image: "/images/remise.jpg", title: "Celebrations de fin d'annee" },
  	{ image: "/images/sport.jpg", title: "Evénement sportif" },
		{ image: "/images/sport2.jpg", title: "Rencontre inter-école" },
	];

	return (
		<section className="text-akwaba">
			<div className="container">
				<div className="image-1ere">
					<img src="/images/bienvenue.jpg" alt="IUSSE" />
				</div>
				<h1>Akwaba</h1>
				<div className="content-horizontal">
					<span className="text-span">
						Ouverte à toutes et à tous.
						<br />
						<br />
						L’Université IUSSE propose à tous les candidats lycéens, étudiants ou personnes en reprise d’études un vaste panel de formations.
						<br />
						Consultez le catalogue des formations de l’Université IUSSE pour
						découvrir les programmes, leurs objectifs ainsi que les possibilités
						de poursuites d’études et d’insertion professionnelle.
					</span>
					<Card
						image="/images/iusse1.jpg"
						link="/cycles/bts"
						width="580px"
						height="305px"
						imageHeight="305px"
						clickable={false}
					/>
				</div>
				<h2>Nos cycles</h2>
				<section className="admissions-grid">
					<Card
						image="/images/bts_2.png"
						title="Le cycle BTS ( Brevet de technicien superieur )"
						link="/cycles/bts"
						width="550px"
						height="380px"
						imageHeight="300px"
					/>
					<Card
						image="/images/systeme-lmd.jpg"
						title="Le cycle LMD ( LICENCE - MASTER - DOCTORAT )"
						link="/cycles/lmd"
						width="550px"
						height="380px"
						imageHeight="300px"
					/>
				</section>
				<h3>Nos Actualités</h3>
				<div className="carousel-wrapper">
					<div className="carousel-akwaba">
						{cartes.map((carte, index) => (
							<Card
								key={`original-${index}`}
								image={carte.image}
								title={carte.title}
								width="350px"
								height="280px"
								imageHeight="220px"
								clickable={false}
							/>
						))}
						{cartes.map((carte, index) => (
							<Card
								key={`duplicate-${index}`}
								image={carte.image}
								title={carte.title}
								width="350px"
								height="280px"
								imageHeight="220px"
								clickable={false}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
